import { useState } from "react"
import { common, aboutStyles } from "./styles"

// Accept profile as a prop
export default function About({ profile }) {
  // Split name for styling
  const nameParts = profile?.name ? profile.name.split(" ") : []
  const firstName = nameParts[0] || ""
  const lastName = nameParts.slice(1).join(" ") || ""

  // Certificate modal state
  const [isTranscriptModalOpen, setIsTranscriptModalOpen] = useState(false)
  const [currentTranscriptIndex, setCurrentTranscriptIndex] = useState(0)

  const toggleTranscriptModal = () => setIsTranscriptModalOpen(!isTranscriptModalOpen)
  const nextTranscript = () =>
    setCurrentTranscriptIndex((prev) => (prev + 1) % (profile?.transcripts?.length || 1))
  const prevTranscript = () =>
    setCurrentTranscriptIndex((prev) =>
      (prev - 1 + (profile?.transcripts?.length || 1)) % (profile?.transcripts?.length || 1)
    )

  return (
    <section style={common.section} id="about">
      <div style={common.sectionContent}>
        <h1 style={aboutStyles.name}>
          {firstName}
          <span style={aboutStyles.nameSpan}> {lastName}</span>
        </h1>
        <p style={{ ...common.lead, marginBottom: "2rem" }}>
          {profile?.bio || "Loading biography..."}
        </p>
        {/* View certificate button */}
        {profile?.transcripts?.length > 0 && (
          <button
            style={{
              backgroundColor: "#7749F8",
              color: "#fff",
              padding: "0.75rem 1rem",
              borderRadius: "0.25rem",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
            onClick={toggleTranscriptModal}
          >
            View certificate
          </button>
        )}
      </div>
      {/* Modal for transcripts */}
      {isTranscriptModalOpen && profile?.transcripts?.length > 0 && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              padding: "2rem",
              width: "90%",
              maxWidth: "500px",
              textAlign: "center",
            }}
          >
            <img
              src={profile.transcripts[currentTranscriptIndex]}
              alt={`Transcript ${currentTranscriptIndex + 1}`}
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "1rem",
                borderRadius: "0.25rem",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
              <button
                style={{
                  backgroundColor: "#e5e7eb",
                  color: "#1f2937",
                  fontWeight: "bold",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                }}
                onClick={prevTranscript}
              >
                Previous
              </button>
              <button
                style={{
                  backgroundColor: "#e5e7eb",
                  color: "#1f2937",
                  fontWeight: "bold",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                }}
                onClick={nextTranscript}
              >
                Next
              </button>
            </div>
            <button
              style={{
                backgroundColor: "#f87171",
                color: "white",
                fontWeight: "bold",
                padding: "0.75rem 1rem",
                borderRadius: "0.25rem",
                cursor: "pointer",
                width: "100%",
              }}
              onClick={toggleTranscriptModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  )
}
